import { Link, route } from 'preact-router';
import { useEffect } from 'preact/hooks';
import render from 'preact-render-to-string';
import Table from '../components/ui/Table.js';
import Modal from '../components/ui/Modal.js';
import useApp from '../context/AppContext.js';
import useModal from '../hooks/useModal.js';
import { eventType, sexItems } from '../consts.js';
import { getAge, getRemainingDays } from '../functions.js';
import { findAnimalPhotos } from '../api/api.js';

export default function Animal({ id }) {
    const { isModalShowing, toggleModal } = useModal();
    const { animals, events, eventsType } = useApp();
    if (!animals || !events) return (<div>Loading...</div>);
    const animal = animals.find(animal => parseInt(animal.id) === parseInt(id));
    if (!animal) return (<div>Loading animal...</div>);
    const columns = [
        { label: "Nom", accessor: "name", sortable: false },
        { label: "Sexe", accessor: "sex", sortable: false },
        { label: "Age", accessor: "birthday", sortable: false },
        { label: "Suitee", accessor: "followed", sortable: false },
    ];
    const columnsEvents = [
        { label: "Type", accessor: "type", sortable: false },
        { label: "Date", accessor: "date", sortable: false },
        { label: "Terrain", accessor: "location", sortable: false },
        { label: "Notes", accessor: "notes", sortable: false },
    ];
    const selectedEvents = events.filter(event => parseInt(event.animalId) == parseInt(id) && event.type != 2);
    selectedEvents.sort((a, b) => {
        if (a.type < b.type) return -1;
        if (a.type > b.type) return 1;
        return 0;
    })

    const age = getAge(animal.birthday);
    let wtMeat = getRemainingDays(animal.wt_date, animal.wt_meat);
    if (wtMeat < 0) wtMeat = 0;
    let wtMilk = getRemainingDays(animal.wt_date, animal.wt_milk);
    if (wtMilk < 0) wtMilk = 0;

    let children = [];
    let displayFarrow = false;
    if (animal.sex == 2) {
        children = animals.filter(animal => parseInt(animal.motherId) === parseInt(id));
        displayFarrow = true;
    }
    else {
        children = animals.filter(animal => parseInt(animal.fatherId) === parseInt(id));
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function cellFormat(value, accessor, data) {
        let str = value;
        if (accessor == 'sex') {
            str = sexItems[value];
        } else if (accessor == 'name') {
            str = render(<Link href={'/animal/' + data.id}>{value}</Link>);
            data.markers.forEach(marker => {
                str += '<div class="marker-shape" style="background-color:' + marker.color + '"></div>';
            })
            if (data.exited) {
                str = '<div class="exited">' + str + '</div>';
            }
        } else if (accessor == 'birthday') {
            str = getAge(value);
        }
        return str;
    }

    function getLinkEventByType(type, id) {
        let urlBase = "";
        switch (type) {
            case '1':
                urlBase = "/event-movement/";
                break;
            case '2':
                urlBase = "/event-marker/";
                break;
            case '3':
                urlBase = "/event-weight/";
                break;
            case '4':
                urlBase = "/event-other/";
                break;
            case '5':
                urlBase = "/event-farrow/";
                break;
            case '6':
                urlBase = "/event-exit/";
                break;
            default:
                break;
        }
        return render(<Link href={urlBase + id}>{eventType[type]}</Link>);
    }

    function cellFormatEvents(value, accessor, data) {
        let str = value;
        switch (accessor) {
            case 'date':
                str = new Date(data.dateApi).toLocaleDateString();
                break;
            case 'type':
                str = getLinkEventByType(value, data.id);
                break;
            case 'location':
                str = <Link className="nav-animal" href={'/location/' + data.locationId}><div dangerouslySetInnerHTML={{ __html: data.locationName }} /></Link>
                str = render(str);
                break;
            case 'notes':
                str = value.substring(0, 60);
                if (str.length < value.length) str += '... ' + render(<div style="width: 280px" />);
                break;
            default:
        }
        return str;
    }

    function gotoEdit() {
        route('/form-animal/' + animal.id);
    }

    function gotoWeight() {
        route('/event-weight/animal/' + animal.id);
    }

    function gotoMovement() {
        route('/event-movement/animal/' + animal.id);
    }

    function gotoMarker() {
        route('/event-marker/animal/' + animal.id);
    }

    function gotoFarrow() {
        route('/event-farrow/animal/' + animal.id);
    }

    function gotoExit() {
        route('/event-exit/animal/' + animal.id);
    }

    function gotoOther() {
        route('/event-other/animal/' + animal.id);
    }

    const handleEventsTypeChange = (e) => {
        route('/event-other/type/' + e.target.value + '/animal/' + animal.id);
    }

    const loadPhotos = (e) => {
        findAnimalPhotos(animal.id).then((photos) => {
            const parent = e.target.parentElement;
            parent.innerHTML = "";
            photos.forEach((photo, idx) => {
                let image = document.createElement('img');
                image.src = photo.photoFilename;
                image.className = "animalPhoto";
                parent.append(image);
            })
        })
    }

    return (
        <div class="container-md detail">
            <div class="text-center position-fixed bg-white w-100 p-2 pb-0" style="margin-left: -0.75rem !important; top: 48px">
                <h1 class={(animal.exited ? " exited" : "")} >{animal.name}</h1>
                <div class="row ps-3 pe-3">
                    <a class="col m-2 btn btn-secondary btn-sm" href="#">Fiche</a>
                    <a class="col m-2 btn btn-secondary btn-sm" href="#children">Enfants</a>
                    <a class="col m-2 btn btn-secondary btn-sm" href="#events">Historique</a>
                    <a class="col m-2 btn btn-secondary btn-sm" href="#todo">A faire</a>
                </div>
            </div>
            <div class="pt-5" style="margin-top: 104px">
                <div class="row m-0 p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <div class="col pe-0">
                        <label>Numéro : </label> {animal.number}
                    </div>
                    <div>
                        {
                            animal.markers.map((marker) => {
                                return (
                                    <span key={marker.id}><div class="marker-shape" style={{ backgroundColor: marker.color }} /> {marker.name}</span>
                                )
                            })
                        }
                    </div>
                </div>
                <div class="row m-0 p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <div class="col ps-0"><label>Sexe : </label> {sexItems[animal.sex]}</div>
                    <div class="col pe-0"><label>Sevré : </label> {animal.weaned || typeof animal.weaned == "undefined" ? "oui" : "non"}</div>
                </div>
                {animal.sex == 2 &&
                    <div class="row m-0 p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                        <div class="col ps-0"><label>Suitée : </label> {animal.followed}</div>
                        <div class="col pe-0"><label>Tarie : </label> {animal.driedup || typeof animal.driedup == "undefined" ? "oui" : "non"}</div>
                    </div>
                }
                <div class="row m-0 p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <div class="col ps-0"><label>Age : </label> {age}</div>
                    <div class="col pe-0"><label>Poids : </label> {animal.weight} kg</div>
                </div>
                <div class="p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <label>Terrain :</label>&nbsp;
                    {animal.location && <Link href={'/location/' + animal.location.id}>{animal.location.fullName}</Link>}
                </div>
                <div class="p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <div><label>Mère : </label> <Link href={'/animal/' + animal.motherId}>{animal.motherName}</Link></div>
                    <div style={{ whiteSpace: "pre-wrap" }}>
                        <label>Notes à propos de la mère : </label><br />
                        {animal.mother_notes}
                    </div>
                </div>
                <div class="p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <div><label>Père : </label> <Link href={'/animal/' + animal.fatherId}>{animal.fatherName}</Link></div>
                    <div style={{ whiteSpace: "pre-wrap" }}>
                        <label>Notes à propos du père : </label><br />
                        {animal.father_notes}
                    </div>
                </div>
                <div class="p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <label>Qualités : </label> <br />
                    {animal.qualities}
                </div>
                <div class="p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <label>Tares : </label> <br />
                    {animal.flaws}
                </div>
                <div style={{ whiteSpace: "pre-wrap" }} class="p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <label>Notes  : </label><br />
                    {animal.notes}
                </div>
                <div style={{ whiteSpace: "pre-wrap" }} class="p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <label>Photos  : </label><br />
                    <div id="photos" class="animalPhotos">
                        <a href="#null" id="loadPhotos" onclick={loadPhotos}>Charger les photos</a>
                    </div>
                </div>
                <div class="row m-0 p-2 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    <div class="col ps-0"><label>T.A. Viande : </label> {wtMeat} </div>
                    <div class="col pe-0"><label>T.A. Lait : </label> {wtMilk} </div>
                    <em>(TAV={animal.wt_meat};  TAL={animal.wt_milk}; TAD={new Date(animal.wt_date).toLocaleDateString()})</em>
                </div>
                <input class="btn btn-primary btn-lg mt-3" type="button" value="Editer" onClick={gotoEdit} />
                <div id="children" class="overflow-auto" style="padding-top: 140px">
                    {children.length > 0 && <Table id="animals" caption="Enfants" columns={columns} selectable={false} data={children} cellFormat={cellFormat} />}
                </div>
                <div id="events" class="overflow-auto" style="padding-top: 140px">
                    <Table id="events" caption="Historique" columns={columnsEvents} selectable={false} data={selectedEvents} cellFormat={cellFormatEvents} />
                </div>
            </div>
            <Modal id="ModalAction" isShowing={isModalShowing} hide={() => toggleModal('ModalAction')} title="Choisissez une action">
                <div class="d-grid gap-2">
                    <button type="button" class="list-button btn btn-secondary" onClick={gotoWeight}>Peser</button>
                    <button type="button" class="list-button btn btn-secondary" onClick={gotoMovement}>Déplacer</button>
                    <button type="button" class="list-button btn btn-secondary" onClick={gotoMarker}>Marquer</button>
                    {displayFarrow && <button type="button" class="list-button btn btn-secondary" onClick={gotoFarrow}>Mise bas</button>}
                    <button type="button" class="list-button btn btn-secondary" onClick={gotoExit}>Sortie</button>
                    <button type="button" class="list-button btn btn-secondary" onClick={gotoOther}>Autre évènement</button>
                    {
                        eventsType &&
                        <div class="form-floating  mb-3">
                            <select class="form-control" id="eventsType" name="eventsType" onchange={(e) => handleEventsTypeChange(e)}>
                                <option value="">- Aucune -</option>
                                {
                                    eventsType.map((evt) => {
                                        return (
                                            <option key={evt.id} value={evt.id}>{evt.name}</option>
                                        )
                                    })
                                }
                            </select>
                            <label class="form-label" for="eventsType">Evènement type</label>
                        </div>
                    }
                </div>
            </Modal>
            <input class="action-button btn btn-primary btn-lg position-fixed bottom-0 end-0 me-3 mb-3" type="button" value="Action" id="toggleModalAction" onClick={() => toggleModal('ModalAction')} />
        </div>
    );
}